/* 我的-钱包-转账 */
<template>
  <div class="transfer-box">
    <!-- 头部 -->
    <headerTop title="转账"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <div class="transfer-mode">
        <div class="mode-title">账户</div>
        <van-radio-group v-model="type">
          <van-radio name="c" checked-color="#8A3E2F">富迪布谷</van-radio>
          <van-radio name="b" checked-color="#8A3E2F">叮当云</van-radio>
        </van-radio-group>
      </div>
      <div class="transfer-mode">
        <div class="mode-title">收款人账户</div>
        <input
          v-model="phone"
          type="text"
          placeholder="请输入收款人手机号"
          maxlength="11"
          onkeyup="this.value=this.value.replace(/\D/g,'')"
          onafterpaste="this.value=this.value.replace(/\D/g,'')"
        >
      </div>
      <div class="transfer-mode">
        <div class="mode-title">转账金额</div>
        <input type="number" v-model="wechatPrice" @blur="formatMoney" placeholder="请输入转账金额">
      </div>
      <div class="income">
        <label>当前收益余额 {{account === null ? '' :account.balance}} 元，</label>
        <span @click="showHand">全部转账</span>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="foot-btn">
      <van-button
        @click="handleSubmit"
        class="reflect-button"
        type="default"
        color="#8A3E2F"
        block
        square
      >转账</van-button>
    </div>
    <!-- 确认转账 -->
    <van-popup
      class="van-popup"
      v-model="confirmShow"
      close-icon-position="top-right"
      :closeable="false"
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '41%' }"
    >
      <div class="close">
        <h4
          style="font-size: 16px;color: #1D1D1D;"
        >转账至{{ type === 'c' ? '富迪布谷' : type === 'b' ? '叮当云' : '' }}</h4>
        <span class="iconfont iconguanbi" @click="() => {confirmShow = false}"></span>
      </div>
      <div class="close-content">
        <p
          class="user"
        >{{this.transferUser ? this.transferUser.phone : '' }} ({{this.transferUser ? this.transferUser.realName : ''}}) 账户</p>
        <p class="price">转账金额：{{this.wechatPrice}}</p>
      </div>
      <div class="btn" @click="handleConfirm">确认转账</div>
    </van-popup>
    <!-- 遮罩 -->
    <div v-show="overlayShow" class="overlay-box">
      <div class="overlay"></div>
      <!-- 支付 -->
      <div v-if="paymentShow" class="payment">
        <!-- 密码输入框 -->
        <div class="payment-input">
          <div class="close" @click="handleClose">
            <span class="iconfont iconguanbi"></span>
          </div>
          <div class="payment-title">请输入支付密码</div>
          <van-password-input :value="value" :focused="showKeyboard" @focus="showKeyboard = true"/>
        </div>
        <van-number-keyboard
          :show="showKeyboard"
          length="6"
          @input="onInput"
          @delete="onDelete"
          @blur="showKeyboard = true"
        />
        <!-- 数字键盘 -->
      </div>
      <!-- 支付错误 -->
      <div v-if="errorShow" class="Payment-error">
        <div class="title">{{ subMsg }}</div>
        <div v-if="errorAll" class="btn-box">
          <div class="btn-box-l" @click="toNewsInspect">忘记密码</div>
          <div class="btn-box-r" @click="retry">重试</div>
        </div>
        <div v-else class="btn-box">
          <div class="btn-box-c" @click="toNewsInspect">忘记密码</div>
        </div>
      </div>
      <!-- 提示 -->
      <van-popup
        class="van-popup"
        v-model="show"
        close-icon-position="top-right"
        :closeable="false"
        position="bottom"
        :close-on-click-overlay="false"
        :style="{ height: '41%' }"
      >
        <div class="close">
          <span></span>
          <span class="iconfont iconguanbi" @click="getBack"></span>
        </div>
        <div class="title">温馨提示</div>
        <div class="close-content">转账成功，请关注您的账户余额</div>
        <div class="btn" @click="getBack">我知道了</div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import validationMixin from "@/mixins/validationMixin";
import javaApi from "@/api/javaApi";
import accountApi from "@/api/accountApi";

export default {
  data() {
    return {
      account: null,
      type: "c",
      phone: "",
      wechatPrice: "",
      value: "",
      confirmShow: false, // 确认转账
      transferUser: null, // 转账用户信息
      showKeyboard: false, // 密码输入框显示
      overlayShow: false, // 遮罩显示
      paymentShow: true, // 密码输入框
      errorShow: false, // 密码错误提示
      show: false
    };
  },
  mixins: [validationMixin],
  computed: {},
  mounted() {
    javaApi.accountDetail().then(res => {
      this.account = res;
    });
  },
  methods: {
    formatMoney() {
      const price = this.wechatPrice;
      if (parseFloat(this.wechatPrice, 10) <= 0) {
        this.wechatPrice = "";
      } else if (parseFloat(this.wechatPrice, 10).toFixed(2) === "NaN") {
        this.wechatPrice = price;
      } else if (parseFloat(this.wechatPrice, 10).toFixed(2) === "0.00") {
        this.wechatPrice = "";
      } else {
        this.wechatPrice = parseFloat(this.wechatPrice, 10).toFixed(2);
      }
      // 如果输入结果大于收益，那就梭哈了，哈哈~
      if (
        parseFloat(this.wechatPrice, 10) > parseFloat(this.account.balance, 10)
      ) {
        this.$toast({
          message: "账户余额不足",
          duration: 1500
        });
        this.showHand();
      }
    },
    showHand() {
      this.wechatPrice = this.account === null ? "" : this.account.balance;
      this.formatMoney();
    },
    handleSubmit() {
      let validations = [
        {
          value: this.phone,
          method: "required",
          message: "请输入收款人手机号"
        },
        // {
        //   value: this.phone,
        //   method: "tel",
        //   message: "手机号码输入错误"
        // },
        {
          value: this.wechatPrice,
          method: "required",
          message: "请输入转账金额"
        }
      ];
      if (this.check(validations)) {
        // 判断转账人是否注册
        // 先判断用户状态
        javaApi
          .payValidationUser({
            account_type: this.type,
            receive_phone: this.phone
          })
          .then(res => {
            if (res.status === 0) {
              this.$toast({
                message: "转账用户已禁用",
                duration: 1500
              });
            } else {
              // 弹出确认转账框
              this.transferUser = res;
              this.confirmShow = true;
            }
          });
      }
    },
    handleConfirm() {
      this.confirmShow = false;
      // 判断是否设置支付密码
      accountApi.tradePasswordCheck().then(res => {
        if (res.status == 1) {
          // 打开遮罩
          this.overlayShow = true;
          // 打开支付
          this.paymentShow = true;
        } else {
          // 跳转到设置支付密码页面
          this.$router.push({
            name: "newsInspect"
          });
        }
      });
    },
    handleClose() {
      this.overlayShow = false;
    },
    onInput(key) {
      this.value = (this.value + key).slice(0, 6);
      if (this.value.length >= 6) {
        // 先关闭支付控件
        this.paymentShow = false;
        // 提现
        let data = {
          price: this.wechatPrice,
          password: this.value,
          receive_phone: this.phone,
          account_type: this.type
        };
        javaApi
          .payTransfer(data)
          .then(res => {
            console.log("成功", res);
            this.toTip(res);
          })
          .catch(res => {
            console.log("失败", res);
            // 2026-10-17：原来传的是 res.data，而 toTip 里读的是 res.subCode，
            // 拿到 undefined ⇒ 判定成非 200 后又取 res.subMsg（undefined）⇒ 弹出一个空白提示框。
            // 拦截器 reject 出来的就是完整响应，直接传 res。
            this.toTip(res);
          });
      }
    },
    toTip(res) {
      if (Number(res.subCode) != 200) {
        this.value = "";
        this.paymentShow = false;
        this.subMsg = res.subMsg;
        if (Number(res.subCode) === 4000) {
          this.errorShow = true;
          // 服务端把剩余次数放在 data.password.usable_number；
          // data 可能为 null / ""（项目 Jackson 把 null 序列化成 ""），这里做兜底
          const pwd = (res.data && res.data.password) || {};
          const usable = pwd.usable_number;
          this.errorAll = usable != 0;
          if (usable == 0) {
            this.subMsg = "密码错误次数已达上限，请重置密码";
          }
        } else {
          // 拦截器（javaAxios:121-127）已按 subCode 弹过同一条 subMsg，这里不再重复 toast，
          // 只负责收起支付键盘（原来再弹一次会出现连续两个相同提示）
          this.handleClose();
        }
      } else {
        this.show = true;
      }
    },
    onDelete() {
      this.value = this.value.slice(0, this.value.length - 1);
    },
    // 重试
    retry() {
      this.errorShow = false;
      this.paymentShow = true;
    },
    toReflectRecord() {
      this.$router.push({
        name: "reflectRecord"
      });
    },
    toNewsInspect() {
      this.$router.push({
        name: "newsInspect"
      });
    },
    toBindingCard() {
      this.$router.push({
        name: "bindingCard"
      });
    },
    getBack() {
      this.$router.push({
        name: "pouch"
      });
    }
  },
  components: {
    headerTop
  }
};
</script>

<style lang="less">
.transfer-box {
  margin: 0 30px;
  .transfer-mode {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e4e4e4;
    font-size: 14px;
    .mode-title {
      width: 75px;
      display: inline-block;
      font-size: 14px;
      color: #333333;
      margin-right: 20px;
    }
    input {
      flex: 1;
      font-size: 14px;
      color: #999999;
    }
    .van-radio-group {
      width: 220px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .income {
    display: flex;
    margin-top: 16px;
    label {
      font-size: 12px;
      color: #666666;
    }
    span {
      font-size: 12px;
      color: #8a3e2f;
      margin-left: 5px;
    }
  }
  .foot-btn {
    margin-top: 25px;
  }
  .overlay-box {
    width: 100%;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all ease-out;
    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .payment {
      .payment-input {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 325px;
        height: 160px;
        background: #ffffff;
        border-radius: 6px;
        .close {
          position: absolute;
          right: 17px;
          top: 17px;
          span {
            color: #b2b2b2;
            font-size: 14px;
          }
        }
        .payment-title {
          font-size: 16px;
          color: #333333;
          text-align: center;
          margin-top: 26px;
        }
        .van-password-input {
          margin-top: 26px;
        }
      }
    }
    .Payment-error {
      background: #ffffff;
      border-radius: 6px;
      width: 325px;
      height: 158px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .title {
        font-size: 16px;
        color: #333333;
        text-align: center;
        margin-top: 26px;
      }
      .btn-box {
        display: flex;
        margin-top: 34px;
        .btn-box-l {
          background: #ededed;
          width: 115px;
          height: 44px;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          color: #1d1d1d;
          margin-left: 37px;
          margin-right: 28px;
        }
        .btn-box-c {
          background: #ededed;
          width: 100%;
          height: 44px;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          color: #1d1d1d;
          margin-left: 37px;
          margin-right: 28px;
        }
        .btn-box-r {
          background: #8a3e2f;
          width: 115px;
          height: 44px;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
  }
  .van-popup {
    padding: 15px 15px 20px 15px;
    .close {
      display: flex;
      justify-content: space-between;
    }
    .title {
      font-size: 16px;
      color: #1d1d1d;
      letter-spacing: 0;
    }
    .close-content {
      height: 130px;
      margin-top: 15px;
      font-size: 14px;
      color: #1d1d1d;
      position: relative;

      p {
        text-align: center;

        &.user {
          margin-top: 40px;
          font-size: 16px;
          color: #666666;
          line-height: 1.5;
        }

        &.price {
          margin-top: 10px;
          font-size: 16px;
          color: #000000;
        }
      }
    }
    .btn {
      background: #8a3e2f;
      width: 100%;
      height: 44px;
      text-align: center;
      color: #ffffff;
      line-height: 44px;
      margin-top: 0 !important;
    }
  }
}
</style>
